<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1101001000011ogvtn.vue
*@ 컴포넌트설명 :[베트남] 예금 상품 > 예금 상품 상세(개인보통예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <div class="scroll">
      <contents-header
        :bg-type="true"
        :tabs="true"
        :summary="true"
        title="EKYC-02-01"
        description="EKYC-06-03"
      >
        <template #tab>
          <div class="tabs bg-type" id="tabs">
            <button
              v-for="(tab, index) in tabs"
              class="tab-button tab-button--type1"
              :class="{ active: currentTab === index }"
              @click="tabClick(index)"
              :key="index"
            >{{ $t(tab) }}</button>
          </div>
        </template>
        <template #summary>
          <!-- 금리 이율 -->
          <div class="summary mtop-20">
            <div v-if="lang != $config.LANG_ENG" class="item item-row">
              <div class="tit">
                <span class="exchange-unit">VND</span>
                <span v-if="lang == $config.LANG_KOR" class="text">연</span>
              </div>
              <div v-if="lang == $config.LANG_KOR" class="percent">0.10%</div>
              <div v-else class="percent">0.10%/năm</div>
            </div>
            <div v-else class="item">
              <div class="tit">
                <span class="exchange-unit">VND</span>
              </div>
              <div class="percent">
                0.10%
                <span>annually</span>
              </div>
            </div>
            <div v-if="currentTab == 1">
              <div v-if="lang != $config.LANG_ENG" class="item item-row">
                <div class="tit">
                  <span class="exchange-unit">USD</span>
                  <span v-if="lang == $config.LANG_KOR" class="text">연</span>
                </div>
                <div v-if="lang == $config.LANG_KOR" class="percent">0.00%</div>
                <div v-else class="percent">0.00%/năm</div>
              </div>
              <div v-else class="item">
                <div class="tit">
                  <span class="exchange-unit">USD</span>
                </div>
                <div class="percent">
                  0.00%
                  <span>annually</span>
                </div>
              </div>
            </div>
          </div>
          <!--// 금리 이율 end -->
        </template>
      </contents-header>
      <article class="contents mtop-24">
        <div v-show="currentTab == 0">
          <!--한국어-->
          <template v-if="lang == $config.LANG_KOR">
            <article class="contents">
              <dl class="dlist dlist-item--type5">
                <dt>상품유형</dt>
                <dd>보통예금</dd>
                <dt>상품개요</dt>
                <dd>일시적 여유자금 보관목적으로 수시로 입금 및 출금을 할 수 있고 예치기간을 정하지 않은 예금</dd>
                <dt>가입대상</dt>
                <dd>개인(IC칩 신분증을 소지한 18세 이상 베트남 거주자)</dd>
                <dt>계약기간</dt>
                <dd>제한없음</dd>
                <dt>가입통화</dt>
                <dd>VND(고객별 1좌)</dd>
                <dt>금리 및 이율</dt>
                <dd>VND 연 0.10%</dd>
                <dt>이체한도</dt>
                <dd>
                  1일 5억VND 비대면 이체한도 제한
                  <br />(신분증을 지참하여 영업점 방문 시 한도제한 해제 가능)
                </dd>
                <dt>수수료</dt>
                <dd>해당무</dd>
                <dt>가입방법</dt>
                <dd>스타뱅킹 가입</dd>
                <dt>가입시 필요서류</dt>
                <dd v-if="sessionInfo.isLogin && sessionInfo.userInfo.operGroupCd === 'VN1'">베트남국적고객: IC칩 기반 신분증
                  <br />핸드폰 소유자 검증 결과(1414번으로 “TTTB” 메시지 전송)
                  <br />거래목적확인서
                  <br />(예 : 고용계약서, 서비스 계약서, 상업 송장, 등록금 고지서 등)
                </dd>
                <dd v-else>베트남국적고객: IC칩 기반 신분증</dd>
              </dl>
            </article>
          </template>
          <!--영어-->
          <template v-else-if="lang == $config.LANG_ENG">
            <article class="contents">
              <dl class="dlist dlist-item--type5">
                <dt>Types</dt>
                <dd>Current Account</dd>
                <dt>About the products</dt>
                <dd>Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds</dd>
                <dt>Eligibilty</dt>
                <dd>Personal customer(Vietnamese residents aged 18+ with an IC chip based ID card)</dd>
                <dt>Contract Terms</dt>
                <dd>No restrictions</dd>
                <dt>Available currency</dt>
                <dd>VND(1 account per customer)</dd>
                <dt>Loan Rate</dt>
                <dd>VND 0.10% annually</dd>
                <dt>Transfer Limit</dt>
                <dd>
                  A daily transfer limit of 500 million VND for mobile transactions
                  <br />(Limit can be lifted by visiting a branch with your ID card)
                </dd>
                <dt>Fees</dt>
                <dd>N/A</dd>
                <dt>How to apply</dt>
                <dd>Mobile banking app</dd>
                <dt>Required documents for application</dt>
                <dd v-if="sessionInfo.isLogin && sessionInfo.userInfo.operGroupCd === 'VN1'">Vietnamese customers : IC chip-based ID card
                  <br />Phone number ownership verification (Send message “TTTB” to 1414)
                  <br />Transaction purpose supporting documents
                  <br />(Ex : Employment contract, Service agreement, Commercial invoices, Tuition fee notification, etc.)
                </dd>
                <dd v-else>Vietnamese customers : IC chip-based ID card</dd>
              </dl>
            </article>
          </template>
          <!--베트남-->
          <template v-else>
            <article class="contents">
              <dl class="dlist dlist-item--type5">
                <dt>Hình thức sản phẩm</dt>
                <dd>Tiền gửi thông thường</dd>
                <dt>Giới thiệu sản phẩm</dt>
                <dd>Là loại tiền gửi không kì hạn, cho phép khách hàng có thể tự do nộp và rút tiền với mục đích quản lý tạm thời số tiền đang có</dd>
                <dt>Đối tượng gia nhập</dt>
                <dd>Khách hàng cá nhân(Là công dân Việt Nam đủ 18 tuổi trở lên và có CCCD gắn chíp)</dd>
                <dt>Thời gian hợp đồng</dt>
                <dd>Không giới hạn</dd>
                <dt>Loại tiền tệ gia nhập</dt>
                <dd>VND(1 khách hàng chỉ được mở 1 tài khoản trực tuyến)</dd>
                <dt>Lãi suất</dt>
                <dd>0.10% hàng năm</dd>
                <dt>Hạn mức giao dịch</dt>
                <dd>
                  Hạn mức cho các giao dịch trực tuyến là 500 triệu VNĐ một ngày
                  <br />(Quý khách có thể mang CCCD gắn chíp đến chi nhánh để đăng kí hủy bỏ hạn mức)
                </dd>
                <dt>Biểu phí</dt>
                <dd>Không có nội dung tương ứng</dd>
                <dt>Cách thức gia nhập</dt>
                <dd>Đăng kí Mobile banking</dd>
                <dt>Giấy tờ cần thiết khi gia nhập</dt>
                <dd v-if="sessionInfo.isLogin && sessionInfo.userInfo.operGroupCd === 'VN1'">Khách hàng là công dân Việt Nam có CCCD gắn chíp
                  <br />Xác minh số điện thoại chính chủ (Soạn “TTTB” gửi 1414)
                  <br />Tài liệu chứng minh mục đích giao dịch
                  <br />(Ví dụ: Hợp đồng lao động, Thỏa thuận dịch vụ, Hóa đơn bán hàng, Thông báo học phí, v.v…)
                </dd>
                <dd v-else>Khách hàng là công dân Việt Nam có CCCD gắn chíp</dd>
              </dl>
            </article>
          </template>
        </div>
        <div v-show="currentTab == 1">
          <!--한국어-->
          <template v-if="lang == $config.LANG_KOR">
            <article class="contents">
              <dl class="dlist dlist-item--type5">
                <dt>상품유형</dt>
                <dd>보통예금</dd>
                <dt>상품개요</dt>
                <dd>일시적 여유자금 보관목적으로 수시로 입금 및 출금을 할 수 있고 예치기간을 정하지 않은 예금</dd>
                <dt>가입대상</dt>
                <dd>개인</dd>
                <dt>계약기간</dt>
                <dd>제한없음</dd>
                <dt>가입통화</dt>
                <dd>VND, USD</dd>
                <dt>금리 및 이율</dt>
                <dd>약정이율 : USD 연 0.00%, VND 연 0.10%</dd>
                <dt>수수료</dt>
                <dd>해당무</dd>
                <dt>가입방법</dt>
                <dd>스타뱅킹 가입, 영업점 가입</dd>
                <dt>가입시 필요서류</dt>
                <dd>
                  본인확인서류
                  <br />베트남국적고객 : IC칩 기반 신분증
                  <br />기타국적고객 : 여권 및 비자
                </dd>
              </dl>
            </article>
          </template>
          <!--영어-->
          <template v-else-if="lang == $config.LANG_ENG">
            <article class="contents">
              <dl class="dlist dlist-item--type5">
                <dt>Types</dt>
                <dd>Current Account</dd>
                <dt>About the products</dt>
                <dd>Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds</dd>
                <dt>Eligibilty</dt>
                <dd>Personal customer</dd>
                <dt>Contract Terms</dt>
                <dd>No restrictions</dd>
                <dt>Available currency</dt>
                <dd>VND, USD</dd>
                <dt>Loan Rate</dt>
                <dd>Agreed interest rate : USD 0.00% annually , VND 0.10% annually</dd>
                <dt>Fees</dt>
                <dd>N/A</dd>
                <dt>How to apply</dt>
                <dd>Mobile banking app, Apply at the branch</dd>
                <dt>Required documents for application</dt>
                <dd>
                  Identity verification documents
                  <br />Vietnamese customers : IC chip-based ID card
                  <br />Other nationalities : Passport and visa
                </dd>
              </dl>
            </article>
          </template>
          <!--베트남-->
          <template v-else>
            <article class="contents">
              <dl class="dlist dlist-item--type5">
                <dt>Hình thức sản phẩm</dt>
                <dd>Tiền gửi thông thường</dd>
                <dt>Giới thiệu sản phẩm</dt>
                <dd>Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian</dd>
                <dt>Đối tượng gia nhập</dt>
                <dd>Cá nhân</dd>
                <dt>Thời gian hợp đồng</dt>
                <dd>Không giới hạn</dd>
                <dt>Loại tiền tệ gia nhập</dt>
                <dd>VND, USD</dd>
                <dt>Lãi suất</dt>
                <dd>Lãi suất cam kết : USD 0.00%/năm , VND 0.10% /năm</dd>
                <dt>Biểu phí</dt>
                <dd>Không có nội dung tương ứng</dd>
                <dt>Cách thức gia nhập</dt>
                <dd>Đăng kí Mobile banking, Tham gia chi nhánh</dd>
                <dt>Giấy tờ cần thiết khi gia nhập</dt>
                <dd>
                  Giấy tờ cần thiết để mở tài khoản tiền gửi
                  <br />Khách hàng Việt Nam : Thẻ CCCD gắn chíp
                  <br />Khách hàng nước ngoài : Hộ chiếu hoặc Visa
                </dd>
              </dl>
            </article>
          </template>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import Common from "@/components/basic/Common";
export default {
  extends: Common,
  computed: {
    ...mapFields(["lang"]),
    ...mapFields(["siteCode", "sessionInfo"]),
  },
  data() {
    return {
      currentTab: 0,
      tabs: ["EKYC-02-03", "EKYC-02-04"],
    };
  },
  methods: {
    tabClick(index) {
      this.currentTab = index;
      this.$emit("tabindex", this.currentTab);
    },
  },
};
</script>
